<script setup lang="ts">
import {Avatar} from "../Library";

const props = defineProps<{
    i: number;
    anonymization: string;
    member: any;
    isOwner: boolean;
}>();
</script>
<template>
    <div class="flex grow items-center gap-2">
        <Avatar class="h-8 w-8 flex-none shrink-0 text-xs" :user="member" shape="circle" />
        <div class="flex grow items-center gap-1">
            <span :class="[!isOwner && anonymization === 'initials_only' ? 'font-bold' : 'font-medium']">
                {{ member.first_name }}
            </span>
            <span v-if="member.last_name" class="font-bold">{{ member.last_name }}</span>
        </div>
    </div>
</template>
<style scoped></style>
